<template>
    <div class="page-container">
        <!-- 签到信息 -->
        <div id="top" class="signInfoData" @click="changeInfoTap">
            <!-- 状态 -->
            <div
                class="signStatus flex align-center"
                :class="[state.signData.className]"
            >
                <van-icon
                    v-if="state.signData.status === 1"
                    name="underway"
                    size="17px"
                />
                <!-- <img
                    v-if="state.signData.status === 20"
                    class="icon_status"
                    src="
                        ../../assets/img/icons/icon_jxz.png
                    "
                    alt=""
                />
                <img
                    v-if="state.signData.status === 30"
                    class="icon_status"
                    src="../../assets/img/icons/icon_gb.png"
                    alt=""
                /> -->
                <span>{{ state.signData.statusText }}</span>
            </div>

            <div class="signInfoList signInfoName flex justify-start">
                <span class="signInfo_label">活动名称：</span>
                <span class="signInfo_top_val line_clamp_2">{{
                    state.signData.title
                }}</span>
            </div>
            <div class="signInfoList flex justify-start">
                <span class="signInfo_label">活动时间：</span>
                <span class="signInfo_text"
                    >{{ state.signData.startTime_s }}~{{
                        state.signData.endTime_s
                    }}</span
                >
            </div>
            <div
                v-if="!state.hideInfo"
                class="signInfoList flex align-center justify-start"
            >
                <span class="signInfo_label">创建人：</span>
                <span class="signInfo_text">{{
                    state.signData.shop_clerk_name || "无"
                }}</span>
            </div>
            <div
                v-if="!state.hideInfo"
                class="signInfoList flex align-start justify-start"
            >
                <span class="signInfo_label">参与门店：</span>
                <span class="signInfo_text">{{
                    state.signData.shop_names.join("、")
                }}</span>
            </div>
            <div
                v-if="
                    !state.hideInfo &&
                    (state.signData.points || state.signData.coupon_names)
                "
                class="signInfoList flex align-center justify-start"
            >
                <span class="signInfo_label">活动奖励：</span>
                <span
                    class="signInfo_text"
                    v-if="state.signData.points && state.signData.coupon_names"
                    >{{
                        state.signData.points +
                        "积分" +
                        "、" +
                        state.signData.coupon_names.join("、")
                    }}</span
                >
                <span class="signInfo_text" v-else
                    >{{
                        state.signData.points
                            ? state.signData.points + "积分"
                            : ""
                    }}{{
                        state.signData.coupon_names
                            ? state.signData.coupon_names.join("、")
                            : ""
                    }}</span
                >
            </div>
            <div
                v-if="!state.hideInfo && state.signData.admin_tag_names"
                class="signInfoList flex justify-start"
            >
                <span class="signInfo_label">活动标签：</span>
                <span class="signInfo_text">{{
                    state.signData.admin_tag_names.join("、")
                }}</span>
            </div>
            <div
                v-if="!state.hideInfo && state.signData.intro"
                class="signInfoList flex align-start justify-start"
            >
                <span class="signInfoTitle">活动详情：</span>
                <span class="signInfoDesc">{{ state.signData.intro }}</span>
            </div>

            <div class="signInfoBtn">
                <van-icon
                    v-if="state.hideInfo"
                    name="arrow-down"
                    size="22.5px"
                    color="#DCBB89"
                />
                <van-icon
                    v-else
                    name="arrow-up"
                    size="22.5px"
                    color="#DCBB89"
                />
            </div>
            <div
                class="down flex justify-se"
                v-if="state.signData.status !== 30"
            >
                <van-button
                    plain
                    color="#DCBB89"
                    v-if="state.signData.status === 20"
                    @click.stop="
                        OperationActivity('end', state.signData, index)
                    "
                    >立即结束</van-button
                >
                <van-button
                    plain
                    color="#DCBB89"
                    v-if="state.signData.status === 1"
                    @click.stop="
                        OperationActivity('cancel', state.signData, index)
                    "
                    >取消活动</van-button
                >
                <van-button
                    plain
                    color="#DCBB89"
                    v-if="state.signData.status === 1"
                    @click.stop="
                        OperationActivity('start', state.signData, index)
                    "
                    >立即开始</van-button
                >
                <van-button
                    plain
                    color="#DCBB89"
                    v-if="state.signData.status === 40"
                    @click.stop="
                        OperationActivity('delete', state.signData, index)
                    "
                    >删除活动</van-button
                >
            </div>
        </div>

        <!-- 搜索与筛选 -->
        <div id="filter" class="searchBox">
            <div class="signInfoSearch">
                <div class="signInfoSearchInput flex align-center">
                    <van-icon name="search" size="22.5px" color="#999999" />
                    <input
                        v-model="state.paras.user_search"
                        class="searchInput"
                        placeholder-style="font-size: 16px;color: #999999;"
                        placeholder="请输入客户姓名或手机号搜索"
                        @input="bindInput"
                        @blur="inputBlur"
                        @confirm="bindconfirm"
                    />
                    <van-icon
                        v-if="state.paras.user_search.length > 0"
                        class="clearIcon"
                        name="clear"
                        color="#B2B2B2"
                        size="20"
                        @click.stop="clearSearch"
                    />
                </div>
                <img
                    class="signInfo_filter"
                    src="../../assets/img/icons/filter.png"
                    alt=""
                    @click.stop="filterTag"
                />
            </div>

            <!-- 时间切换标签 -->
            <div class="activity_btm_timeBox">
                <div
                    v-for="item in state.signtagArr"
                    :key="item.value"
                    class="activity_btm_timeList"
                    :class="{ sel: state.selDay === item.value }"
                    @click.stop="switchSignTag(item.value)"
                >
                    {{ item.label }}
                </div>
            </div>

            <!-- 统计 -->
            <div class="signInfoStat flex align-center justify-start">
                <span>
                    累计{{ state.signData.user_num || "0" }}人参与，共参与{{
                        state.signData.sign_num || "0"
                    }}次
                </span>
            </div>
        </div>

        <!-- 签到列表 -->
        <div
            class="signInfoBox"
            :style="{
                maxHeight: `calc(100% - ${state.topHeight}px - ${state.filterHeight}px - 60px)`,
            }"
            @scroll="onScroll"
        >
            <div
                v-if="state.list.length"
                ref="scrollContent"
                class="box_scroll-content"
            >
                <div
                    v-for="(item, index) in state.list"
                    :key="index"
                    class="signInfo_li"
                >
                    <div
                        class="signInfo_item signInfo_nameBox flex align-center justify-between"
                    >
                        <div class="signInfo_left flex">
                            <span class="signInfo_name line_clamp_1">{{
                                item.user_name
                            }}</span>
                            <span class="signInfo_nickName line_clamp_1">{{
                                item.nick_name
                            }}</span>
                        </div>
                        <div class="signInfo_right">
                            累计签到<span class="signInfo_item_val">{{
                                item.sign_count || 0
                            }}</span
                            >天
                        </div>
                    </div>
                    <div class="signInfo_item">
                        <span class="signInfo_item_label">手机号码：</span
                        >{{ item.user_phone }}
                    </div>
                    <div class="signInfo_item">
                        <span class="signInfo_item_label">所属门店：</span
                        >{{ item.shop_name }}
                    </div>
                    <div class="signInfo_item">
                        <span class="signInfo_item_label">最近签到时间：</span
                        >{{ item.last_sign_time || "" }}
                    </div>
                </div>
                <!-- 触底加载触发器 -->
                <div
                    v-if="!state.hasMore"
                    ref="loadMoreTrigger"
                    class="load-more-trigger"
                ></div>
            </div>
            <!-- 空状态 -->
            <van-empty
                class="empty-wrapper"
                v-if="state.list.length === 0"
                description="暂无数据"
            />
        </div>

        <!-- 底部导出按钮（自定义组件 footer） -->
        <div class="bottom_button_box">
            <van-button
                round
                block
                type="primary"
                color="#DCBB89"
                class="save-btn"
                @click="exportList"
            >
                导出数据
            </van-button>
        </div>

        <!-- 筛选弹窗 -->
        <van-popup
            v-model:show="state.showFilter"
            :z-index="100"
            position="bottom"
            round
        >
            <div class="filterBox">
                <div class="filter_tool">
                    <span>筛选</span>
                    <van-icon
                        class="filter_close"
                        name="close"
                        size="24px"
                        @click.stop="closeFilter"
                    />
                </div>
                <div class="filter_timeBox">
                    <div
                        class="filter_time_title flex align-center justify-between"
                    >
                        <span>筛选组织或门店</span>
                        <span
                            class="filter_time_title_btn"
                            @click="czDepartment"
                            >重置</span
                        >
                    </div>
                    <div
                        class="filter_time_inputBox"
                        @click="bindDepartmentChange"
                    >
                        <div
                            class="filter_signDa_input flex align-center justify-between"
                        >
                            <span v-if="state.paras.department_name">{{
                                state.paras.department_name
                            }}</span>
                            <span
                                class="filter_signDa_plo"
                                v-if="!state.paras.department_name"
                                >请选择组织或门店(默认当前账号分部下的全部组织)</span
                            >
                            <van-icon
                                name="arrow-down"
                                size="30rpx"
                                color="#666"
                            />
                        </div>
                    </div>
                </div>
                <div class="filter_timeBox filter_signDay">
                    <div class="filter_signDa_title">
                        签到天数
                        <span class="filter_signDa_title_small"
                            >(默认值: 0，代表全部)</span
                        >
                    </div>
                    <div class="filter_signDa_inputBox">
                        <van-stepper
                            v-model="state.paras.sign_day"
                            integer
                            :min="0"
                            :max="state.maxDay + 1"
                            @change="stepperChange"
                        />
                    </div>
                </div>

                <div class="filter_timeBox filter_btmList">
                    <div
                        class="filter_time_title flex align-center justify-between"
                    >
                        <span>自定义时间段</span>
                        <span class="filter_time_title_btn" @click.stop="czTime"
                            >重置</span
                        >
                    </div>
                    <div class="filter_time_inputBox">
                        <div
                            class="filter_time_input flex align-center justify-between"
                            data-type="startTime"
                            @click.stop="showPopup"
                        >
                            <span>{{
                                state.startTime || state.startTimeText
                            }}</span>
                            <img
                                class="icon_time"
                                src="../../assets/img/icons/icon_time.png"
                                alt=""
                            />
                        </div>
                        <span class="filter_time_input_label"> - </span>
                        <div
                            class="filter_time_input flex align-center justify-between"
                            data-type="endTime"
                            @click.stop="showPopup"
                        >
                            <span>{{
                                state.endTime || state.endTimeText
                            }}</span>
                            <img
                                class="icon_time"
                                src="../../assets/img/icons/icon_time.png"
                                alt=""
                            />
                        </div>
                    </div>
                </div>

                <div class="filter_tagBtnBox">
                    <div class="filter_btn" @click.stop="czFilter">重置</div>
                    <div class="filter_btn" @click.stop="qrFilter">确认</div>
                </div>
            </div>
        </van-popup>

        <!-- 时间选择弹窗 -->
        <van-popup
            v-model:show="state.showTime"
            position="bottom"
            :z-index="999"
            teleport="body"
            @close="closePopup"
        >
            <van-date-picker
                v-model="state.currentDate"
                title="选择时间 (年/月/日)"
                :min-date="state.minDate"
                :max-date="state.maxDate"
                :formatter="state.formatter"
                @confirm="confirmTime"
                @cancel="closePopup"
            />
        </van-popup>

        <!-- 导出弹窗（选择事业部） -->
        <van-popup
            v-model:show="state.showExport"
            position="bottom"
            @close="closePopup"
        >
            <van-picker
                :columns="state.regionColumns"
                :default-index="state.defaultIndex"
                show-toolbar
                title="选择导出到企微主体"
                @confirm="confirmExport"
                @cancel="closePopup"
            />
        </van-popup>

        <!-- 选择部门组件（自定义 sel-department） -->
        <!-- 选择部门 -->
        <sel-department
            v-model:show="state.showTree"
            :visible="state.showTree"
            :position="state.position"
            :tree-data="state.allLocationData"
            :operableUuids="state.allLowerLevel"
            type="group"
            :selectedItem="state.selectedItem"
            :top="state.top"
            :height="state.height"
            zIndex="999"
            :overlay-top="state.overlayTop"
            @close="closeLocationModal"
            @confirm="onDeptChange"
        />
    </div>
</template>

<script setup>
import { ref, reactive, computed, onMounted, onUnmounted, nextTick } from "vue";
import {
    showToast,
    showLoadingToast,
    showSuccessToast,
    showFailToast,
    showDialog,
} from "vant";
import { useActivityStore, useDepartmentStore } from "@/stores";
import {
    getDepartmentListAll,
    getDeptAndPost,
    setDefaultDepartment,
    getFirmRegionDepartment,
    getDepartmentLowerLevel,
} from "@/utils/common";
// 引入 moment（或 dayjs）用于日期处理
// import moment from "moment";
import dayjs from "dayjs";
import { setStatusStyle } from "@/utils/common.js";
// 假设工具函数从指定路径引入
import {
    setSignDate,
    setDefaultTime,
    getPreviousThreeDays,
} from "@/utils/common";
// 假设 API 模块
// import api from '@/api/attendance'
// import newApi from '@/api/api'
import activityApi from "@/utils/api/activity.js";

// 全局变量（需根据实际项目替换为 store 或 provide/inject）
// const userInfo = inject('userInfo') 或使用 store
const imgHeaderUrl = ref(""); // 从环境变量或全局配置获取
import SelDepartment from "@/components/selDepartment.vue";

// ---------- 响应式数据 ----------
const localDepartmentdata = ref(
    JSON.parse(localStorage.getItem("departmentdata")) || {}
);
const state = reactive({
    activity: useActivityStore().getActivity(),
    signData: useActivityStore().getActivity(), // 签到详情信息
    daysRanges: [], // 时间范围
    selDay: "", // 选择时间
    signtagArr: [], // 时间标签
    maxDay: "", // 最大天数

    paras: {
        department_name: "", // 部门名称
        department_uuid: "", // 部门uuid
        sign_day: "", // 签到天数
        user_search: "", // 搜索用户
        start_sign_time: "", // 开始签到时间
        end_sign_time: "", // 结束签到时间
    },
    pagination: {
        page: 1,
        page_size: 5,
        total: 0,
    },
    hasMore: false, // 是否有更多数据

    // 弹窗
    showFilter: false, // 筛选弹窗
    showTime: false, // 时间弹窗
    timeType: 0, // 弹窗类型 1：开始时间 2： 结束时间
    start_time: "", // 开始时间  时间戳
    startTime: "", // 开始时间  年月日
    end_time: "", // 结束时间  时间戳
    endTime: "", // 结束时间  年月日
    startTimeText: "开始时间",
    endTimeText: "结束时间",

    currentDate: new Date(),
    minDate: new Date(),
    maxDate: new Date(),
    formatter(type, value) {
        if (type === "year") {
            value.text += "年";
        }
        if (type === "month") {
            value.text += "月";
        }
        if (type === "day") {
            value.text += "日";
        }
        return value;
    },

    // 列表
    department_name: "", // 部门名称
    department_uuid: "", // 部门uuid
    search: "", // 搜索
    list: [],
    total: 0, // 总数
    page: 1,
    pageSize: 20,
    isLastPage: false,

    // 签到导出
    // showExportSign: false,
    // export_startTime: "", // 导出开始时间  时间戳
    // exportStartTime: "", // 导出开始时间  年月日
    // export_endTime: "", // 导出结束时间  时间戳
    // exportEndTime: "", // 导出结束时间  年月日

    // 选择组织
    showTree: false, // 选择组织弹窗
    // top: 0,
    height: 400,
    overlayTop: 0,
    position: "bottom",
    allLocationData: [], // 所有部门列表
    departmentInfo: [], // 部门列表
    selDepartmentInfo: {}, // 当前选择部门信息
    selectedLocation: {}, // 当前选择部门名称
    selectedItem: {}, // 当前选择部门信息

    hideInfo: true, // 隐藏信息
    topHeight: 0, // 顶部高度
    filterHeight: 0, // 筛选高度

    showExport: false, // 是否显示导出弹窗
    regionColumns: [], // 事业部列
    regionList: [], //事业部列表
    defaultIndex: 0, // 默认选中第一个事业部
});

// // ---------- 计算属性 ----------
// // 日期格式化器（用于 van-datetime-picker）
// const formatter = (type, value) => {
//     if (type === "year") return `${value}年`;
//     if (type === "month") return `${value}月`;
//     if (type === "day") return `${value}日`;
//     return value;
// };

// ---------- 方法 ----------
// 设置默认时间
const funSetDefaultTime = () => {
    // 调用工具函数 setSignDate 和 setDefaultTime
    state.signtagArr = setSignDate(state.daysRanges);
    const { start_time, startTime, end_time, endTime } = setDefaultTime(
        state.signData.start_time,
        state.signData.end_time
    );
    state.start_time = startTime;
    state.startTime = startTime;
    state.end_time = endTime;
    state.endTime = endTime;
};

// 计算最大日期范围
const setMinMaxDate = () => {
    // ✅ 确保 signData 数据存在且有效
    if (!state.signData.start_time || !state.signData.end_time) {
        return;
    }

    // ✅ 使用 dayjs 解析确保格式正确，再转回 Date 对象
    const startStr = dayjs(state.signData.start_time).format("YYYY-MM-DD");
    const endStr = dayjs(state.signData.end_time).format("YYYY-MM-DD");

    state.minDate = new Date(startStr); // 最小日期
    const now = new Date();
    const endTime = new Date(endStr);

    // ✅ 确保是有效的 Date 对象
    if (isNaN(state.minDate.getTime()) || isNaN(endTime.getTime())) {
        return;
    }

    state.maxDate = now < endTime ? now : endTime;
    state.maxDay = dayjs(state.maxDate).diff(dayjs(startStr), "days");
    state.daysRanges = getPreviousThreeDays(startStr, endStr);

    // ✅ 设置 currentDate 为当前选中日期（数组格式）
    const defaultDate =
        state.timeType === 1
            ? state.startTime || startStr
            : state.endTime || endStr;

    const [year, month, day] = defaultDate.split("-");
    state.currentDate = [year, month, day]; // ['2024', '06', '15']
    funSetDefaultTime();
};

// 登录后初始化（替代原 loginOnce）
const initAfterLogin = async (callback) => {
    // 原逻辑调用了 getFirmRegionDepartment、getDeptAndPost 等
    // let firm_region_uuid = localDepartmentdata.value.department_uuid;
    let firm_region_uuid = 1;
    let signDepartment_uuid =
        (await getFirmRegionDepartment(firm_region_uuid)) || [];
    let departmentInfo = useDepartmentStore().getDepartment("departmentInfo");
    let selDepartmentInfo =
        useDepartmentStore().getDepartment("selDepartmentInfo") || {};
    if (!departmentInfo || departmentInfo.length === 0) {
        departmentInfo = await getDeptAndPost();
    }
    let operableUuids = [];
    departmentInfo.forEach((item) => {
        if (
            item.department.deep > 3 &&
            item.department.firm_region_uuid === firm_region_uuid
        ) {
            let index = operableUuids.indexOf(item.department.uuid);
            if (index === -1) {
                operableUuids.push(item.department.uuid);
            }
        }
        if (item.department.deep <= 3) {
            let index = operableUuids.indexOf(signDepartment_uuid);
            if (index === -1) {
                operableUuids.push(signDepartment_uuid);
            }
        }
    });
    let allLowerLevel = await getDepartmentLowerLevel(operableUuids, "sign");

    state.operableUuids = operableUuids;
    state.departmentInfo = departmentInfo || [];
    state.selDepartmentInfo = selDepartmentInfo || {};
    state.selectedItem = selDepartmentInfo || {};
    state.allLowerLevel = allLowerLevel || [];

    fetchLocationData(); // 获取部门列表
    // 这里省略具体实现
    callback && callback();
};

// 获取部门列表（原 fetchLocationData）
const fetchLocationData = async () => {
    const toast = showLoadingToast({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
    });
    state.allLocationData =
        (await getDepartmentListAll(state.operableUuids, "sign")) || [];
    toast.close();
};

// 切换时间标签
const switchSignTag = (value) => {
    if (state.selDay === value) {
        state.selDay = "";
        funSetDefaultTime();
    } else {
        state.selDay = value;
        state.start_time = value;
        state.end_time = value;
        state.startTime = value;
        state.endTime = value;
    }
    state.pagination.page = 1;
    getActivityData();
};

// 搜索输入
const bindInput = (e) => {
    state.paras.user_search = e.target.value;
};

const inputBlur = () => {
    if (state.paras.user_search) {
        getActivityData();
    } else {
        funSetDefaultTime();
        getActivityData();
    }
};

const bindconfirm = () => {
    if (state.paras.user_search) {
        getActivityData();
    } else {
        funSetDefaultTime();
        getActivityData();
    }
};

const clearSearch = () => {
    state.paras.user_search = "";
    getActivityData();
};

// // 获取列表数据
// const getData = async (para) => {
//     // showLoadingToast({ message: '加载中', forbidClick: true })
//     // const req = {
//     //   uuid: signData.value.uuid,
//     //   search: search.value,
//     //   page: para.page,
//     //   page_size: pageSize.value,
//     // }
//     // if (search.value) {
//     //   if (/^\d+$/.test(search.value)) req.phone = search.value
//     //   else req.name = search.value
//     // }
//     // if (startTime.value && endTime.value) {
//     //   req.start_time = startTime.value + ' 00:00:00'
//     //   req.end_time = endTime.value + ' 23:59:59'
//     // }
//     // if (sign_day.value) req.sign_num = sign_day.value
//     // if (department_uuid.value) req.department_uuid = department_uuid.value
//     // const res = await api.getShopSignEventInfo(req)
//     // closeToast()
//     // if (res.code !== 200) {
//     //   showToast({ type: 'fail', message: res.msg || '网络异常，请重试？' })
//     //   return
//     // }
//     // const data = res.data
//     // let newList = (data.list || []).map(item => ({
//     //   ...item,
//     //   sign_time: item.sign_time ? dayjs(item.sign_time).format('YYYY-MM-DD HH:mm:ss') : ''
//     // }))
//     // list.value = para.page > 1 ? [...list.value, ...newList] : newList
//     // page.value = para.page
//     // total.value = res.cnt
//     // isLastPage.value = list.value.length >= res.cnt
//     // signData.value.sign_num = data.sign_num || 0
//     // signData.value.user_num = data.user_num || 0
// };

// 加载更多
const loadMore = () => {
    if (!state.hasMore) {
        return;
    }
    getActivityData();
};

// 滚动监听（触底加载）
const onScroll = (e) => {
    const el = e.target;
    if (el.scrollHeight - el.scrollTop <= el.clientHeight + 50) {
        loadMore();
    }
};

// 显示时间选择弹窗
const showPopup = (e) => {
    const type = e.currentTarget.dataset.type;
    if (type === "startTime") {
        state.timeType = 1;
        let [year, month, day] = state.start_time.split("-");
        state.currentDate = [year, month, day] || new Date();
    } else if (type === "endTime") {
        state.timeType = 2;
        let [year, month, day] = state.end_time.split("-");
        state.currentDate = [year, month, day] || new Date();
    }
    state.showTime = true;
};

// 关闭弹窗
const closePopup = () => {
    state.showTime = false;
    state.showExport = false;
};

// 确认时间选择
const confirmTime = ({ selectedValues }) => {
    // selectedValues 是 ['2024', '06', '15'] 数组
    const [year, month, day] = selectedValues;
    const selectedDateStr = `${year}-${month}-${day}`;
    const selectedDate = dayjs(selectedDateStr);

    if (state.timeType === 1) {
        // 检查结束时间是否存在且范围不超过60天
        if (state.end_time) {
            const endDate = dayjs(state.end_time);
            const diffDays = endDate.diff(selectedDate, "days");
            if (diffDays > 60) {
                showToast({ type: "fail", message: "时间范围不得超过60天！" });
                return;
            }
        }

        state.start_time = selectedDateStr; // 格式为 'YYYY-MM-DD'
        state.startTime = selectedDateStr;
    } else if (state.timeType === 2) {
        const newTimeStr = `${selectedDateStr} 23:59:59`;
        const newTimeStamp = new Date(newTimeStr).getTime();
        if (newTimeStamp < dayjs(state.start_time).valueOf()) {
            showToast({ type: "fail", message: "结束时间不得小于开始时间！" });
            return;
        }

        if (state.start_time) {
            const diffDays = dayjs(newTimeStamp).diff(
                dayjs(state.start_time),
                "days"
            );
            if (diffDays > 60) {
                showToast({ type: "fail", message: "时间范围不得超过60天！" });
                return;
            }
        }

        state.end_time = selectedDateStr;
        state.endTime = selectedDateStr;
    }

    closePopup();
};

// 筛选弹窗
const filterTag = () => {
    const min = state.minDate;
    const max = state.maxDate;
    state.maxDay = Math.floor((max - min) / (24 * 60 * 60 * 1000));
    state.showFilter = true;
};

const closeFilter = () => {
    state.showFilter = false;
};
// 重置组织
const czDepartment = () => {
    state.paras.department_name = "";
    state.paras.department_uuid = "";
};
const czTime = () => {
    funSetDefaultTime();
};

const czFilter = () => {
    state.showFilter = false;
    state.selDay = "";
    state.paras.sign_day = "";
    state.paras.department_name = "";
    state.paras.department_uuid = "";
    funSetDefaultTime();
    getActivityData();
};

const qrFilter = () => {
    getActivityData();
    state.showFilter = false;
};

const confirmExport = async (e) => {
    // const index = e.selectedIndexes[0] // van-picker 返回格式可能不同
    // const region = regionList.value[index]
    // 构建参数...
    // showLoadingToast({ message: '导出中...', forbidClick: true })
    // const res = await api.exportShopSignEventInfo(req)
    // closeToast()
    // if (res.code !== 200) {
    //   showToast({ type: 'fail', message: res.msg || '导出失败，请重试？' })
    //   return
    // }
    // showToast({ type: 'success', message: '导出文件已发送至您的企业微信' })
    // showExport.value = false
    // defaultIndex.value = index
};

// 部门相关（保留结构）
const bindDepartmentChange = () => {
    state.selectedItem = {};
    state.showTree = true;
};
const closeLocationModal = () => {
    state.showTree = false;
};
const onDeptChange = (e) => {
    const dept = e;
    state.paras.department_name = dept.name || ""; // 部门名称
    state.paras.department_uuid = dept.uuid || ""; // 部门id
    state.showTree = false;
};

// 步进器变化
const stepperChange = (value) => {
    state.paras.sign_day = value;
};

// // ---------- 生命周期 ----------
onMounted(() => {
    // 从路由获取参数（假设使用 Vue Router）
    // const pageData = useRoute().query.pageData
    // if (!pageData) {
    //   showToast({ type: 'fail', message: '请返回列表重试？' })
    //   return
    // }
    // signData.value = JSON.parse(pageData)
    // 获取活动详情
    getActivityDetail();

    setMinMaxDate();

    // 模拟 onShow
    initAfterLogin(() => {
        getTopHeight();
        getActivityData();
    });

    // 设置 IntersectionObserver 监听触底
    const observer = new IntersectionObserver(
        (entries) => {
            if (entries[0].isIntersecting) {
                loadMore();
            }
        },
        { threshold: 0.1 }
    );
    nextTick(() => {
        const trigger = document.querySelector(".load-more-trigger");
        if (trigger) observer.observe(trigger);
    });
    // 清理 observer
    onUnmounted(() => {
        observer.disconnect();
    });
});
// --------------------------------------- 方法 事件
// 获取高度
const getTopHeight = () => {
    nextTick(() => {
        const topEl = document.getElementById("top");
        const filterEl = document.getElementById("filter");
        state.topHeight = topEl ? topEl.offsetHeight : 0;
        state.filterHeight = filterEl ? filterEl.offsetHeight : 0;
    });
};

// 切换顶部信息显示
const changeInfoTap = () => {
    state.hideInfo = !state.hideInfo;
    getTopHeight();
};
// 导出相关
const exportList = async () => {
    const toast = showLoadingToast({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
    });
    let req = {
        uuid: state.signData.uuid,
        ...state.pagination,
    };
    if (state.paras.department_uuid) {
        req.department_uuid = state.paras.department_uuid;
    }
    if (state.paras.sign_day) {
        req.sign_day = state.paras.sign_day;
    }
    if (state.paras.user_search) {
        req.user_search = state.paras.user_search;
    }
    if (state.startTime && state.endTime) {
        req.start_sign_time = state.startTime + " 00:00:00";
        req.end_sign_time = state.endTime + " 23:59:59";
    }
    const res = await activityApi.exportActivityData(req);
    let time = setTimeout(() => {
        clearTimeout(time);
        toast.close();
    }, 2000);
    if (res.code !== 200) {
        showToast({ type: "fail", message: res.msg || "导出数据失败" });
        return false;
    }
    showSuccessToast({ message: "导出数据成功" });
};
// 操作活动
const OperationActivity = async (type, activity, index) => {
    let text = "";
    let apiName = "";
    let status = "";
    switch (type) {
        case "start":
            text = "立即开始";
            apiName = "startActivity";
            status = 20;
            break;
        case "end":
            text = "立即结束";
            apiName = "endActivity";
            status = 30;
            break;
        case "cancel":
            text = "取消";
            apiName = "cancelActivity";
            status = 40;
            break;
        case "delete":
            text = "删除";
            apiName = "deleteActivity";
            status = 0;
            break;
    }
    showDialog({
        title: "提示",
        message: `确定要${text}该活动吗？`,
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
    }).then(
        async () => {
            // onConfirm
            let res = await activityApi[apiName]({
                uuid: activity.uuid,
            });
            if (res.code !== 200) {
                showFailToast(`${text}失败`);
                return;
            }
            showSuccessToast(`${text}成功`);
            if (type === "delete") {
                state.liveList.splice(index, 1);
                return;
            }
            state.signData.status = status;
            state.signData.className = setStatusStyle(status).className;
            state.signData.statusText = setStatusStyle(status).statusText;
        },
        () => {
            // onCancel
            // showFailToast(`${text}取消`);
        }
    );
    // 调用接口
};
// --------------------------------------- 请求
// 获取活动详情
const getActivityDetail = async () => {
    const toast = showLoadingToast({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
    });
    const res = await activityApi.getActivityDetail({
        uuid: state.signData.uuid,
    });
    let time = setTimeout(() => {
        clearTimeout(time);
        toast.close();
    }, 2000);
    if (res.code !== 200) {
        showToast({ type: "fail", message: res.msg || "获取数据失败" });
        return false;
    }
    let data = res.data || {};
    data.startTime_s = dayjs(data.start_time).format("YYYY-MM-DD HH:mm");
    data.endTime_s = dayjs(data.end_time).format("YYYY-MM-DD HH:mm");
    data.className = setStatusStyle(data.status).className;
    data.statusText = setStatusStyle(data.status).statusText;
    state.signData = data;
};
// 获取签到数据
const getActivityData = async () => {
    let req = {
        uuid: state.signData.uuid,
        ...state.pagination,
    };
    if (state.paras.department_uuid) {
        req.department_uuid = state.paras.department_uuid;
    }
    if (state.paras.sign_day) {
        req.sign_day = state.paras.sign_day;
    }
    if (state.paras.user_search) {
        req.user_search = state.paras.user_search;
    }
    if (state.startTime && state.endTime) {
        req.start_sign_time = state.startTime + " 00:00:00";
        req.end_sign_time = state.endTime + " 23:59:59";
    }
    const toast = showLoadingToast({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
    });
    const res = await activityApi.getActivityData(req);
    let time = setTimeout(() => {
        clearTimeout(time);
        toast.close();
    }, 2000);
    if (res.code !== 200) {
        showToast({ type: "fail", message: res.msg || "获取数据失败" });
        return false;
    }
    let list = res.data?.list
        ? res.data?.list?.map((item) => {
              item.last_sign_time = item.last_sign_time
                  ? dayjs(item.last_sign_time).format("YYYY-MM-DD HH:mm:ss")
                  : "";
              return item;
          })
        : [];
    state.list = state.pagination.page === 1 ? list : state.list.concat(list);
    state.pagination.total = res.cnt || 0; // 总条数
    state.hasMore = state.list?.length < state.pagination.total; // 是否还有更多数据
    if (!state.hasMore) {
        state.finished = true;
    }
    if (state.hasMore) {
        state.pagination.page = state.pagination.page + 1;
    }
    state.signData.sign_num = res.data?.sign_total_count || 0;
    state.signData.user_num = res.data?.sign_total_users || 0;
};
</script>

<style lang="scss" scoped>
/* 样式与之前相同，此处省略，可复制之前的 px 版本样式 */
/* 注意：原样式中 rpx 已转换为 px，此处不再重复 */
</style>

<style scoped>
/* 原 WXSS 样式，rpx 转换为 px (2rpx = 1px) */
/* 注意：由于小程序中 page 选择器对应整个页面，这里改为直接作用于根容器 */
.signInfoWrap {
    height: 100%;
    box-sizing: border-box;
}

.status_await {
    color: #43bcd2;
    background-color: rgba(67, 188, 210, 0.15);
}

.status_underway {
    color: #ff9f47;
    background-color: rgba(255, 159, 71, 0.15);
}

.status_end {
    color: #999999;
    background-color: rgba(153, 153, 153, 0.15);
}

/* 签到详情 */
.signInfoData {
    position: relative;
    margin: 0 0 10px; /* 20rpx */
    padding: 14px 12px 8px; /* 28rpx 24rpx 36rpx */
    background-color: #fff;
    /* border-radius: 16rpx; */
}

.signStatus {
    position: absolute;
    top: 10px; /* 20rpx */
    right: 10px; /* 20rpx */
    padding: 6px 7px; /* 12rpx 14rpx */
    font-weight: 500;
    font-size: 14px; /* 28rpx */
    line-height: 16px; /* 32rpx */
    gap: 2px; /* 4rpx */
    border-radius: 0 7.5px 0 7.5px; /* 0 15rpx 0 15rpx */
}

.icon_status {
    width: 17px; /* 34rpx */
    height: 17px; /* 34rpx */
}

.signInfoList {
    margin-bottom: 17px; /* 34rpx */
    font-weight: 400;
    font-size: 16px; /* 32rpx */
    color: #333333;
    line-height: 16px; /* 32rpx */
}
.signInfo_label {
    width: calc(85px);
}
.signInfo_text {
    width: calc(100% - 85px);
}
.signInfoName {
    height: 30px; /* 64rpx */
    line-height: 30px; /* 64rpx */
}

.signInfo_top_val {
    width: calc(100% - 140px); /* 280rpx */
}

.signInfoData .signInfoList:last-child {
    margin-bottom: 0;
}

.signInfoTitle {
    width: 80px; /* 160rpx */
}

.signInfoDesc {
    width: calc(100% - 80px); /* 160rpx */
    height: 50px; /* 100rpx */
    line-height: 20px; /* 40rpx */
    overflow-y: scroll;
}

/* 搜索 */
.searchBox {
    margin-bottom: 10px; /* 20rpx */
    padding: 12px 17px; /* 24rpx 34rpx */
    background-color: #fff;
}

.signInfoSearch {
    margin-bottom: 10px; /* 20rpx */
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px; /* 20rpx */
}

.signInfoSearchInput {
    width: calc(100% - 41px); /* 82rpx */
    padding: 0 10px; /* 20rpx */
    height: 43px; /* 86rpx */
    line-height: 43px; /* 86rpx */
    font-weight: 400;
    font-size: 16px; /* 32rpx */
    color: #333;
    background: #f6f6f6;
    border-radius: 8px; /* 16rpx */
    gap: 4.5px; /* 9rpx */
}

.signInfo_filter {
    width: 40px; /* 82rpx */
    height: 40px; /* 82rpx */
}

.searchInput {
    width: 100%;
    height: 100%;
    font-size: 16px; /* 32rpx */
    line-height: 16px; /* 32rpx */
    color: #333;
    background: #f6f6f6;
    border: none;
}

/* 时间切换 */
.activity_btm_timeBox {
    margin-bottom: 10px; /* 20rpx */
    display: flex;
    width: 100%;
    overflow-x: scroll;
    gap: 14px; /* 28rpx */
    flex-wrap: nowrap;
}

.activity_btm_timeList {
    padding: 0 9px; /* 18rpx */
    min-width: fit-content;
    height: 24px; /* 48rpx */
    font-weight: 400;
    font-size: 16px; /* 32rpx */
    color: #333333;
    line-height: 24px; /* 48rpx */
    background: #f0f0f0;
    border-radius: 12px; /* 24rpx */
}

.activity_btm_timeList.sel {
    color: #ffffff;
    background: #dcbb89;
}

/* 统计 */
.signInfoStat {
    padding: 0 10px; /* 20rpx */
    height: 42.5px; /* 85rpx */
    line-height: 42.5px; /* 85rpx */
    font-weight: 500;
    font-size: 16px; /* 32rpx */
    color: #dcbb89;
    background: #f6f3ee;
    border-radius: 8px; /* 16rpx */
}

/* 列表 */
.signInfoBox {
    position: relative;
    margin: 0 17px 30px; /* 34rpx */
    min-height: 300px; /* 400rpx */
    overflow-y: scroll;
    display: flex;
    justify-content: center;
}
.empty-wrapper {
    position: absolute !important;
    width: 190px;
}

.box_scroll-content {
    flex: 1;
}

.signInfo_li {
    margin-bottom: 10px; /* 20rpx */
    padding: 17px 12px; /* 34rpx 24rpx */
    font-weight: 400;
    font-size: 16px; /* 32rpx */
    color: #666666;
    line-height: 16px; /* 32rpx */
    background: #ffffff;
    border-radius: 8px; /* 16rpx */
}

.signInfo_item {
    margin-bottom: 13px; /* 26rpx */
}

.signInfo_li .signInfo_item:last-child {
    margin-bottom: 0;
}

.signInfo_nameBox .signInfo_left {
    width: calc(100% - 110px); /* 220rpx */
    font-weight: 500;
    font-size: 16px; /* 32rpx */
    color: #333333;
    line-height: 16px; /* 32rpx */
    height: 16px; /* 32rpx */
    gap: 8px; /* 16rpx */
}

.signInfo_name {
    max-width: 50%;
}

.signInfo_nickName {
    max-width: 50%;
}

.signInfo_right {
    width: 110px; /* 220rpx */
    text-align: right;
}

.signInfo_item_val {
    color: #dcbb89;
}

/* 顶部显示隐藏 */
.signInfoBtn {
    width: 100%;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
}

/* filter 弹窗 */
.filterBox {
    padding: 12px 20px; /* 24rpx 40rpx */
    box-sizing: border-box;
}

.icon_time {
    width: 19px; /* 38rpx */
    height: 19px; /* 38rpx */
}

.filter_tool {
    margin-bottom: 20px; /* 40rpx */
    display: flex;
    font-size: 18px; /* 32rpx */
    font-weight: 500;
    justify-content: space-between;
}

.filter_btmList {
    margin-bottom: 35px; /* 70rpx */
}

.filter_signDay {
    margin-bottom: 10px; /* 20rpx */
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.filter_signDa_title {
    height: 30px; /* 60rpx */
    font-weight: 500;
    font-size: 16px; /* 32rpx */
    color: #333333;
    line-height: 30px; /* 60rpx */
}

.filter_signDa_title_small {
    font-size: 13px; /* 26rpx */
    color: #999;
}

.filter_time_title {
    margin-bottom: 10px; /* 20rpx */
    padding: 3px 0 0 0; /* 6rpx 0 0 0 */
    font-weight: 500;
    font-size: 16px; /* 32rpx */
    color: #333333;
    line-height: 19px; /* 38rpx */
}

.dis_flex {
    display: flex;
    justify-content: space-between;
}

.filter_time_title_btn {
    padding-bottom: 0;
    font-weight: 400;
    font-size: 13px; /* 26rpx */
    color: #dcbb89;
    border-bottom: 0.5px solid #dcbb89; /* 1rpx */
}

.filter_time_inputBox {
    margin-bottom: 12px; /* 24rpx */
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 14px; /* 28rpx */
}

.filter_signDa_input {
    padding: 12px 10px; /* 24rpx 20rpx */
    width: 100%;
    height: 45px; /* 90rpx */
    font-weight: 400;
    line-height: 20px; /* 40rpx */
    font-size: 16px; /* 32rpx */
    color: #333;
    border-radius: 8px; /* 16rpx */
    border: 1px solid #dcdcdc; /* 2rpx 实际应为 2rpx≈1px */
    box-sizing: border-box;
}

.filter_signDa_plo {
    font-size: 15px; /* 30rpx */
    color: #999;
}

.filter_time_input {
    padding: 0 9px; /* 18rpx */
    width: 147px; /* 294rpx */
    height: 37px; /* 74rpx */
    line-height: 37px; /* 74rpx */
    font-size: 14px; /* 28rpx */
    text-align: center;
    color: #999999;
    border-radius: 8px; /* 16rpx */
    border: 0.5px solid #f5f5f5; /* 1rpx */
    background: #f5f5f5;
}

.filter_time_input.sel {
    border: 0.5px solid #dcbb89;
}

.filter_time_input_label {
    font-size: 14px; /* 28rpx */
    color: #666666;
    line-height: 16.5px; /* 33rpx */
}

.filter_time_err {
    font-weight: 500;
    font-size: 13.5px; /* 27rpx */
    color: #ff9f47;
    gap: 4px; /* 8rpx */
}

.filter_tagBox {
    max-height: 150px; /* 300rpx */
    overflow-y: scroll;
}

.filter_tag_liBox {
    margin-bottom: 40px; /* 80rpx */
    display: flex;
    flex-wrap: wrap;
    gap: 11px; /* 22rpx */
}

.filter_tagBox {
    margin-bottom: 37px; /* 74rpx */
}

.filter_tagBtnBox {
    display: flex;
    gap: 17px; /* 34rpx */
    font-size: 16px; /* 32rpx */
    align-items: center;
    justify-content: space-between;
    text-align: center;
}

.filter_tag_title {
    margin-bottom: 10px; /* 20rpx */
    font-size: 14px; /* 28rpx */
    color: #333333;
    line-height: 14px; /* 28rpx */
}

.filter_tag_value {
    margin-bottom: 14px; /* 28rpx */
    display: flex;
    gap: 12px; /* 24rpx */
    flex-wrap: wrap;
    justify-content: flex-start;
}

.filter_tag {
    padding: 0 13px; /* 26rpx */
    font-weight: 400;
    height: 22px; /* 44rpx */
    font-size: 14px; /* 28rpx */
    color: #666666;
    line-height: 22px; /* 44rpx */
    background: #f5f5f5;
    border-radius: 25px; /* 50rpx */
}

.filter_tag.sel {
    color: #ffffff;
    background: #dcbb89;
}

.filter_btn {
    width: 100%;
    height: 36px; /* 72rpx */
    font-size: 16px; /* 32rpx */
    color: #ffffff;
    line-height: 36px; /* 72rpx */
    text-align: center;
    border-radius: 18px; /* 36rpx */
    background: #dcbb89;
    border: 1px solid #dcbb89; /* 2rpx */
}

.filter_tagBtnBox .filter_btn:first-child {
    color: #dcbb89;
    background-color: #fff;
}

/* 辅助类（原 wxss 中的 flex 等，可根据需要补充） */
.flex {
    display: flex;
}
.align-center {
    align-items: center;
}
.justify-start {
    justify-content: flex-start;
}
.justify-between {
    justify-content: space-between;
}
.line_clamp_2 {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
}
.line_clamp_1 {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.down {
    padding: 10px 0 0;
    border-top: 2px solid #f3f3f3;
    .van-button {
        height: 38px;
    }
    gap: 10px;
}
</style>
